// Country flag mappings using Unicode flag emojis
export const COUNTRY_FLAGS = {
  'Germany': '🇩🇪',
  'Spain': '🇪🇸', 
  'USA': '🇺🇸',
  'United States': '🇺🇸',
  'France': '🇫🇷',
  'Italy': '🇮🇹',
  'United Kingdom': '🇬🇧',
  'UK': '🇬🇧',
  'Canada': '🇨🇦',
  'Australia': '🇦🇺',
  'Netherlands': '🇳🇱',
  'Belgium': '🇧🇪',
  'Switzerland': '🇨🇭',
  'Austria': '🇦🇹',
  'Portugal': '🇵🇹',
  'Greece': '🇬🇷',
  'Poland': '🇵🇱',
  'Czech Republic': '🇨🇿',
  'Denmark': '🇩🇰',
  'Sweden': '🇸🇪',
  'Norway': '🇳🇴',
  'Finland': '🇫🇮',
  'Ireland': '🇮🇪',
  'Croatia': '🇭🇷',
  'Hungary': '🇭🇺',
  'Romania': '🇷🇴',
  'Slovakia': '🇸🇰',
  'Slovenia': '🇸🇮',
  'Bulgaria': '🇧🇬',
  'Estonia': '🇪🇪',
  'Latvia': '🇱🇻',
  'Lithuania': '🇱🇹',
  'Scotland': '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  'Mexico': '🇲🇽',
  'Brazil': '🇧🇷',
  'Argentina': '🇦🇷',
  'Japan': '🇯🇵',
  'South Korea': '🇰🇷',
  'China': '🇨🇳',
  'India': '🇮🇳',
  'Thailand': '🇹🇭',
  'Vietnam': '🇻🇳',
  'Turkey': '🇹🇷',
  'Russia': '🇷🇺',
  'South Africa': '🇿🇦',
  'Egypt': '🇪🇬',
  'Morocco': '🇲🇦',
  'Chile': '🇨🇱',
  'Peru': '🇵🇪',
  'Colombia': '🇨🇴',
  'Venezuela': '🇻🇪',
  'Ecuador': '🇪🇨',
  'Uruguay': '🇺🇾',
  'Paraguay': '🇵🇾',
  'Bolivia': '🇧🇴',
  'Costa Rica': '🇨🇷',
  'Panama': '🇵🇦',
  'Guatemala': '🇬🇹',
  'Honduras': '🇭🇳',
  'El Salvador': '🇸🇻',
  'Nicaragua': '🇳🇮',
  'Cuba': '🇨🇺',
  'Jamaica': '🇯🇲',
  'Haiti': '🇭🇹',
  'Dominican Republic': '🇩🇴',
  'Puerto Rico': '🇵🇷',
  'New Zealand': '🇳🇿',
  'Philippines': '🇵🇭',
  'Indonesia': '🇮🇩',
  'Malaysia': '🇲🇾',
  'Singapore': '🇸🇬',
  'Israel': '🇮🇱',
  'UAE': '🇦🇪',
  'Saudi Arabia': '🇸🇦',
  'Lebanon': '🇱🇧',
  'Jordan': '🇯🇴',
  'Iran': '🇮🇷',
  'Iraq': '🇮🇶',
  'Syria': '🇸🇾',
  'Pakistan': '🇵🇰',
  'Bangladesh': '🇧🇩',
  'Sri Lanka': '🇱🇰',
  'Nepal': '🇳🇵',
  'Myanmar': '🇲🇲',
  'Cambodia': '🇰🇭',
  'Laos': '🇱🇦',
  'Mongolia': '🇲🇳',
  'Kazakhstan': '🇰🇿',
  'Uzbekistan': '🇺🇿',
  'Kyrgyzstan': '🇰🇬',
  'Tajikistan': '🇹🇯',
  'Turkmenistan': '🇹🇲',
  'Afghanistan': '🇦🇫',
  'Ethiopia': '🇪🇹',
  'Kenya': '🇰🇪',
  'Tanzania': '🇹🇿',
  'Uganda': '🇺🇬',
  'Rwanda': '🇷🇼',
  'Burundi': '🇧🇮',
  'Somalia': '🇸🇴',
  'Djibouti': '🇩🇯',
  'Eritrea': '🇪🇷',
  'Sudan': '🇸🇩',
  'Chad': '🇹🇩',
  'Central African Republic': '🇨🇫',
  'Cameroon': '🇨🇲',
  'Nigeria': '🇳🇬',
  'Ghana': '🇬🇭',
  'Ivory Coast': '🇨🇮',
  'Burkina Faso': '🇧🇫',
  'Mali': '🇲🇱',
  'Niger': '🇳🇪',
  'Senegal': '🇸🇳',
  'Gambia': '🇬🇲',
  'Guinea-Bissau': '🇬🇼',
  'Guinea': '🇬🇳',
  'Sierra Leone': '🇸🇱',
  'Liberia': '🇱🇷',
  'Algeria': '🇩🇿',
  'Tunisia': '🇹🇳',
  'Libya': '🇱🇾'
};

/**
 * Get flag emoji for a country
 * @param {string} country - The country name
 * @returns {string} The flag emoji or fallback globe emoji if not found
 */
export const getCountryFlag = (country) => {
  if (!country || typeof country !== 'string') return '🌍';
  
  // Direct lookup
  if (COUNTRY_FLAGS[country]) {
    return COUNTRY_FLAGS[country];
  }
  
  // Try case-insensitive lookup
  const matchedCountry = Object.keys(COUNTRY_FLAGS).find(
    c => c.toLowerCase() === country.toLowerCase()
  );
  
  if (matchedCountry) {
    return COUNTRY_FLAGS[matchedCountry];
  }
  
  // Fallback globe emoji
  return '🌍';
};

/**
 * Check if a country has a flag emoji available
 * @param {string} country - The country name
 * @returns {boolean} True if flag is available
 */
export const hasCountryFlag = (country) => {
  return getCountryFlag(country) !== '🌍';
};
